import { types } from '../../actions'

function getParticipantSettings(seasons) {     
	const seasonparticipants = {}
  seasons.map(function(season) {
		seasonparticipants[season.id] = getSingleParticipantSettings(season)
	})

	return seasonparticipants
}
function getSingleParticipantSettings(season) {
    
	const { id, minAdvancerRatio, maxAdvancerRatio, leagueMinAthleteMembershipPct, tournamentMinNumberAthletes } = season
	const seasonparticipant = {
		seasonId: id,
		minAdvancerRatio,
		maxAdvancerRatio,
		leagueMinAthleteMembershipPct,
		tournamentMinNumberAthletes,
		isSeasonSet:true
	}
    
  return seasonparticipant
}     
export default function seasonparticipants (state={ },action) {   
        const {  payload } = action      
        switch(action.type) {  
          case (types.Season.FETCH_ACTIVE_SEASONS || types.Season.TRIGGER_SEASON): {           
          const { data } = payload
          if (data) {                
            const defaultId = payload.data[0].id
            const participants = getParticipantSettings(data)
            const initialstate = participants
            const newstate = {
              participants,
              settingsseason:defaultId,
              initialstate,
              participantreset: false
            }
            return Object.assign({},state,{ values:newstate, fields: newstate })
          }
          else {
            return state
          }
        }
        case types.Season.SAVING_SEASON_PARTICIPANT:{
          const savingparticipant=false;
          return  { ...state, 
            values: {
              ...state.values,
              savingparticipant
            },
            fields: {
              ...state.fields,
              savingparticipant
            }
          }
        }
        case types.Season.SAVE_SEASON_PARTICIPANT: {
          const datasaved  = true 
          const savingparticipant = false
          return  { ...state, 
            values: {
              ...state.values,
              savingparticipant,
              datasaved,
              initialstate:state.values.participants,
              participantreset: false         
            },
            fields: {
              ...state.fields,
              savingparticipant,
              datasaved,
              initialstate:state.values.participants,
              participantreset: false  
            }
          }
        }
         case types.Season.TRIGGER_SEASON: {
          const  { data } = payload;
          
          if(data){
          const participants  = getParticipantSettings(data)
          const defaultId = data[data.length - 1].id
          const response = {
            participants,
            settingsseason:defaultId,
            initialstate:participants,
            participantreset: false
          }
          
          return  { ...state, 
            values: {
             ...state.values ,
             ...response,                 
            },
            fields: {
              ...state.fields,
              ...response, 
            }
          }
        } else {
          return state;
        }
            
        }
        case types.RESET_PARTICIPANT_SETTINGS:{
             
          const { initialstate } = state.values

          const response = {
            participants:initialstate,
            participantreset:true
          }
        
          return  { ...state, 
              values: {
                       ...state.values,
                       ...response
                     },
              fields: {
                       ...state.fields,
                       ...response
                     }
           }
        }
        default: return state
        }
}


// WEBPACK FOOTER //
// ./src/redux/reducers/forms/seasonparticipants.js